<div class="h-full min-h-0" *transloco="let t">
  <app-form-shell>
    <div shellHeader>
      <IStepper [steps]="formSteps()" [form]="creationForm" (stepSelect)="goToStep($event)" clickable />
    </div>
    <div shellMain class="h-full min-h-0">
      @switch (currentStepId()) {
        @case ("setup") {
          <app-dsp-create-strategy-setup-step [setup]="creationForm.setup" />
        }
        @case ("media") {
          <app-dsp-create-strategy-media-step
            [media]="creationForm.media"
            [budget]="creationForm.budget"
            [audiences]="creationForm.audiences"
          />
        }
        @case ("budget") {
          <app-dsp-create-strategy-budget-step
            [budget]="creationForm.budget"
            [funnel]="creationForm.setup.dspFunnel().value()"
            [dealId]="creationForm.media.dealId().value()"
          />
        }
        @case ("creative") {
          <app-dsp-create-strategy-creative-step
            [creative]="creationForm.creative"
            [funnel]="creationForm.setup.dspFunnel().value()"
            [mediaCreativeType]="creationForm.media.creativeType().value()"
            [dealId]="creationForm.media.dealId().value()"
            (videoDurationSeconds)="uploadedVideoDurationSeconds.set($event)"
          />
        }
        @case ("audiences") {
          <app-dsp-create-strategy-audiences-step
            [audiences]="creationForm.audiences"
            [funnel]="creationForm.setup.dspFunnel().value()"
          />
        }
        @case ("asins") {
          <app-dsp-create-strategy-asins-step [asins]="creationForm.asins" />
        }
      }
    </div>
    <div shellFooter class="flex items-center justify-end gap-3">
      @if (
        isCreatingStrategy() && creationForm.audiences.audiencePreset().value() !== StrategyDspAudiencePreset.MANUAL
      ) {
        <span class="type-label text-muted-foreground">{{
          t("dsp-create-strategy-page.creating_your_strategy_description")
        }}</span>
      }
      @if (!isFirstStep()) {
        <button iButton variant="secondary" [disabled]="isCreatingStrategy()" (click)="back()">
          {{ t("common.back") }}
        </button>
      }
      <button iButton [disabled]="!canGoNext()" [loading]="isCreatingStrategy()" (click)="next()">
        {{
          isLastStep()
            ? strategyCreationState() === "idle"
              ? t("common.create_strategy")
              : strategyCreationState() === "creating-audiences"
                ? t("dsp-create-strategy-page.creating_your_smart_audiences")
                : t("dsp-create-strategy-page.creating_your_strategy")
            : t("common.next")
        }}
      </button>
    </div>
  </app-form-shell>
</div>
